import { Helmet } from 'react-helmet-async'

export default function SEO({ 
  title = 'Rudovia Life College - Shaping Leaders in Faith, Service, and Innovation',
  description = 'Rudovia Life College offers programs in Theology, Leadership, Nursing, and Architecture. Empowering leaders across Africa with quality Christian education.',
  keywords = 'theology college in Africa, leadership courses online, nursing diploma Zimbabwe, Christian education, Rudovia College, Rev Doc Doreen Mwendesi',
  image = '/g311.png',
  url = 'https://rudovia.ac.zw'
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      <link rel="canonical" href={url} />
    </Helmet>
  )
}
